import { Box, CardActionArea, List, Theme, styled, useMediaQuery } from '@mui/material';

/**
 * These components is part of the VR app V2 redesign
 */

export const BybList = styled(List)(({ theme }) => ({
  overflow: 'auto',
  padding: 0,
}));

interface IListItemLayout {
  columns?: number;
}

/**
 * This component decides how many columns should be in a given list item.
 * The ListItemCell component should be used for each column in the ListItemLayout.
 */
export const ListItemLayout = styled(Box)<IListItemLayout>(({ theme, columns = 6 }) => ({
  display: 'grid',
  gridTemplateColumns: `repeat(${columns}, 1fr)`,
}));

interface IDeviceDependent {
  isMobile?: boolean;
}

const getListItemAreaStyles = (theme: Theme, isMobile?: boolean) => {
  return {
    padding: isMobile ? theme.spacing(1.5, 2, 1.5, 2) : theme.spacing(3),
    backgroundColor: isMobile ? theme.palette.dsBase.v100 : theme.palette.dsSurface.v100,
  };
};

export const ListItemArea = styled(Box)<IDeviceDependent>(({ theme, isMobile = false }) =>
  getListItemAreaStyles(theme, isMobile)
);
export const ListItemActionArea = styled(CardActionArea)<IDeviceDependent>(({ theme, isMobile = false }) =>
  getListItemAreaStyles(theme, isMobile)
);

interface IListItemBase {
  sticky?: boolean;
}

export const ListItemBase = styled('li', {
  shouldForwardProp: (prop) => prop !== 'sticky',
})<IListItemBase>(({ theme, sticky }) => {
  const isSmDown = useMediaQuery(theme.breakpoints.down('sm'));

  return {
    ...(sticky && { position: 'sticky', top: 0, zIndex: 1 }),
    ...(isSmDown ? {} : { marginBottom: theme.spacing(2), margin: theme.spacing(0, 1, 2, 1) }),
  };
});
